import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/59_card_back_golden_crown/59_card_back_golden_crown"
 * Contains 1 texture(s)
 */
export class CardsBacks59CardBackGoldenCrownAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/59_card_back_golden_crown/59_card_back_golden_crown';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '59_golden_crown.png'
    ] as const;
}
